exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.orderInfo .el-dialog .el-dialog__body{\n  padding:0px 20px!important;\n}\n", ""]);

// exports
